// assets/custom-marquee-banner.js
class CustomMarqueeBanner {
  constructor(root) {
    this.root = root;
    this.textPath = root.querySelector('[data-marquee-textpath]');
    if (!this.textPath) return;

    // Treat dataset value as a "speed factor" (0.1 - 2.0 from schema),
    // then map to a MUCH smaller % per frame for readability.
    const speedFactor = parseFloat(root.dataset.marqueeSpeed || '0.4'); // 0.1 - 2.0
    const perFrame = 0.003 * speedFactor; // 0.0003% -> 0.006% per frame
    this.speed = Math.max(0.0001, perFrame);

    this.offset = 0;
    this.raf = null;

    this.animate = this.animate.bind(this);
    this.start();
  }

  start() {
    if (this.raf) return;
    this.raf = requestAnimationFrame(this.animate);
  }

  stop() {
    if (!this.raf) return;
    cancelAnimationFrame(this.raf);
    this.raf = null;
  }

  animate() {
    this.offset -= this.speed;
    this.textPath.setAttribute('startOffset', `${this.offset}%`);
    if (this.offset < -100) this.offset = 0;
    this.raf = requestAnimationFrame(this.animate);
  }
}

function initCustomMarqueeBanners(scope = document) {
  scope.querySelectorAll('[data-custom-marquee-banner]').forEach((el) => {
    if (el.__customMarqueeInstance) return;
    el.__customMarqueeInstance = new CustomMarqueeBanner(el);
  });
}

// Initial load
document.addEventListener('DOMContentLoaded', () => initCustomMarqueeBanners());

// Theme editor (Shopify) support
document.addEventListener('shopify:section:load', (e) => initCustomMarqueeBanners(e.target));
document.addEventListener('shopify:section:section:select', (e) => initCustomMarqueeBanners(e.target));

document.addEventListener('shopify:section:unload', (e) => {
  const root = e.target.querySelector('[data-custom-marquee-banner]');
  if (root?.__customMarqueeInstance) {
    root.__customMarqueeInstance.stop();
    root.__customMarqueeInstance = null;
  }
});

const setCurve = () => {
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  const id = this.root.dataset.sectionId; // we'll add this data attr
  const curveId = isMobile ? `#curvePathMobile-${id}` : `#curvePath-${id}`;
  this.textPath.setAttribute('href', curveId);
};

setCurve();
window.addEventListener('resize', setCurve);
